import React, { Fragment, FunctionComponent } from "react";

import Accordions from "blocks/components/Accordions/Accordions";
import Article from "blocks/components/Article/Article";
import Banner from "blocks/components/Banner/Banner";
import BlogCarousel from "blocks/components/BlogCarousel/BlogCarousel";
import BlogList from "blocks/components/BlogList/BlogList";
import BlogPostCover from "blocks/components/BlogPostCover/BlogPostCover";
import Cards from "blocks/components/Cards/Cards";
import TextCounter from "blocks/components/TextCounter/TextCounter";
import Entrances from "blocks/components/Entrances/Entrances";
import Form from "blocks/components/Form/Form";
import Scratcher from "blocks/components/Scratcher/Scratcher";
import ScratcherB from "blocks/components/ScratcherB/ScratcherB";
import Gallery from "blocks/components/Gallery/Gallery";
import ImageBlock from "blocks/components/ImageBlock/ImageBlock";
import ImageBlockNew from "blocks/components/ImageBlockNew/ImageBlockNew";
import ImageSlideshow from "blocks/components/ImageSlideshow/ImageSlideshow";
import Landing from "blocks/components/Landing/Landing";
import Logos from "blocks/components/Logos/Logos";
import Maps from "blocks/components/Maps/Maps";
import MoodBanner from "blocks/components/MoodBanner/MoodBanner";
import Mundo from "blocks/components/Mundo/Mundo";
import Recipe from "blocks/components/Recipe/Recipe";
import ReportDownload from "blocks/components/ReportDownload/ReportDownload";
import SkaalDigitalPour from "blocks/components/SkaalDigitalPour/SkaalDigitalPour";
import Spots from "blocks/components/Spots/Spots";
import Statements from "blocks/components/Statements/Statements";
import Text from "blocks/components/Text/Text";
import TextAccordions from "blocks/components/TextAccordions/TextAccordions";
import TextImage from "blocks/components/TextImage/TextImage";
import TextImageBanner from "blocks/components/TextImageBanner/TextImageBanner";
import TextImageSlideshow from "blocks/components/TextImageSlideshow/TextImageSlideshow";
import TextMaps from "blocks/components/TextMaps/TextMaps";
import TextText from "blocks/components/TextText/TextText";
import TextVideo from "blocks/components/TextVideo/TextVideo";
import TextVideoBanner from "blocks/components/TextVideoBanner/TextVideoBanner";
import Video from "blocks/components/Video/Video";
import BookingWidget from "blocks/components/BookingWidget/BookingWidget";
import FixrWidget from "blocks/components/Fixr/FixrWidget";
import TextEmbed from "blocks/components/TextEmbed/TextEmbed";
import Embed from "blocks/components/Embed/Embed";
import Carousel from "blocks/components/Carousel/Carousel";
import SimpleContactForm from "blocks/components/SimpleContactForm/SimpleContactForm";
import BarList from "blocks/components/BarList/BarList";
import TextForm from "blocks/components/TextForm/TextForm";
import EasyTableBooking from "blocks/components/EasyTableBooking/EasyTableBooking";
import SportEventsWidget from "blocks/components/SportEventsWidget/SportEventsWidget";
import DynamicForm from "blocks/components/DynamicForm/DynamicForm";
import DynamicFormActivities from "blocks/components/DynamicFormActivities/DynamicFormActivities";

const BLOCK_TYPES: { [key: string]: any } = {
    "blockAccordions": Accordions,
    "blockArticle": Article,
    "blockBanner": Banner,
    "blockBlogCarousel": BlogCarousel,
    "blockBlogList": BlogList,
    "blockBlogPostCover": BlogPostCover,
    "blockCards": Cards,
    "blockCounterText": TextCounter,
    "blockEntrances": Entrances,
    "blockForm": Form,
    "blockScratcher": Scratcher,
    "blockGallery": Gallery,
    "blockImage": ImageBlock,
    "blockImageSlideshow": ImageSlideshow,
    "blockLanding": Landing,
    "blockLogos": Logos,
    "blockMaps": Maps,
    "blockMoodBanner": MoodBanner,
    "blockMundo": Mundo,
    "blockRecipe": Recipe,
    "blockReportDownload": ReportDownload,
    "blockSkaalDigitalPour": SkaalDigitalPour,
    "blockSpots": Spots,
    "blockStatements": Statements,
    "blockText": Text,
    "blockTextAccordions": TextAccordions,
    "blockTextImage": TextImage,
    "blockTextImageBanner": TextImageBanner,
    "blockTextImageSlideshow": TextImageSlideshow,
    "blockTextMaps": TextMaps,
    "blockTextText": TextText,
    "blockTextVideo": TextVideo,
    "blockTextVideoBanner": TextVideoBanner,
    "blockVideo": Video,
    "blockBookingWidget": BookingWidget,
    "blockFixr": FixrWidget,
    "blockTextEmbed": TextEmbed,
    "blockEmbed": Embed,
    "blockCarousel": Carousel,
    "blockImageNew": ImageBlockNew,
    "blockSimpleContactForm": SimpleContactForm,
    "blockBarList": BarList,
    "blockTextForm": TextForm,
    "blockEasyTableBooking": EasyTableBooking,
    "blockSportEventsWidget": SportEventsWidget,
    "blockDynamicForm": DynamicForm,
    "blockDynamicFormActivities": DynamicFormActivities,
    "blockScratcherB": ScratcherB,
};

const ContentPageBlock: FunctionComponent<any> = (props) => {
    const contentType = props.content._contentType;
    const Block = BLOCK_TYPES[contentType];

    if (props?.settings.isTemporarilyHidden === true) {
        return <Fragment></Fragment>;
    }

    return (
        <Fragment>
            {Block ? (
                <Block
                    key={props.contentUdi}
                    {...props}
                />
            ) : null}
        </Fragment>
    );
};

export default ContentPageBlock;
